import { ComponentThemeType } from '@/cl/theme/theme.hooks';

export const SettingsSectionContainerTheme: ComponentThemeType = (currentTheme) => ({
  baseStyle: {
    container: {
      p: { xs: '24px', s: '32px 40px' } as never,
      border: `1px solid ${currentTheme.colors.neutral.light}`,
      justifyContent: 'center',
      borderRadius: '8px',
    },
  },
});
